import { LandscapeDisplay, SafeAreaProvider } from "@hg/layouts"
import { useActivity } from "@hg/recall-frame"
import { useEffect } from "react"

import Resize from "@/components/Resize"
import { getActivityMeta, getCollection } from "@/services/core"
import {
    GlobalStage,
    GlobalView,
    useFetchMeta,
    useGlobalStage,
    useGlobalView,
    useSetPlayer,
} from "@/store"
import { useRoleInfo, useSessionReady } from "@/user/session"
import { collectUserView } from "@/utils/event"
import { sdkReady } from "@/utils/sdk"
import { webSdkReady } from "@/utils/websdk"
import { isDesktop } from "@/utils/ua"
import { Header } from "./Header"

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
    const globalStage = useGlobalStage()
    const globalView = useGlobalView()
    const setPlayer = useSetPlayer()
    const user = useRoleInfo()
    const sessionReady = useSessionReady()

    const fetchMeta = useFetchMeta()
    const setActivityData = useActivity((s) => s.setData)

    const handleFetchRole = async () => {
        if (!user) return null
        const { uid, nickName } = user

        sdkReady((sdk) => {
            sdk.ETL.instance?.setPageProperties?.({
                channel_id: 1,
                game_uid: uid,
            })
            collectUserView()
        })
        setPlayer(null)
        const [collectionRes, , activityMetaRes] = await Promise.all([
            getCollection(),
            fetchMeta(),
            getActivityMeta(),
        ])
        if (activityMetaRes.code === 0) {
            setActivityData(activityMetaRes.data)
        }
        setPlayer({
            state: {},
            collection: collectionRes.code === 0 ? collectionRes.data : null,
        })

        return { uid, nickName }
    }

    // 初始化 WebSDK
    useEffect(() => {
        webSdkReady()
    }, [])

    // 登录成功后加载用户数据
    useEffect(() => {
        if (!user?.uid) return
        handleFetchRole()
    }, [user?.uid])

    return (
        <LandscapeDisplay inRotate={isDesktop() ? false : undefined}>
            <SafeAreaProvider>
                <Resize>
                    {children}
                    <Header />
                </Resize>
            </SafeAreaProvider>
        </LandscapeDisplay>
    )
}

export default Layout
